import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

import Analysis from '../views/Analysis.vue';
import DM from '../views/DM.vue';
import Dice from '../views/Dice.vue';
import Classes from '../views/Classes.vue';
import Races from '../views/Races.vue';
import Mechanics from '../views/Mechanics.vue';
import Setting from '../views/Setting.vue';
import Weapons from '../views/Weapons.vue';

// import { isAuthenticated } from './auth.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Analysis',
    name: 'Analysis',
    component: Analysis
  },
  {
    path: '/DM',
    name: 'DM',
    component: DM
  },
  {
    path: '/Dice',
    name: 'Dice',
    component: Dice
  },
  {
    path: '/Classes',
    name: 'Classes',
    component: Classes
  },
    {
    path: '/Races',
    name: 'Races',
    component: Races
  },
  {
    path: '/Mechanics',
    name: 'Mechanics',
    component: Mechanics
  },
  {
    path: '/Setting',
    name: 'Setting',
    component: Setting
  },
  {
    path: '/Weapons',
    name: 'Weapons',
    component: Weapons
  },
]

const router = new VueRouter({
  mode: 'history',
  // history: createWebHistory(),
  base: process.env.BASE_URL,
  routes
})

export default router
